/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosResponse } from "axios";
import { ChangeStatusResponse } from "../../@types/DRO/ChangeTransferOrderStatusResponse";
import {
  GetAllLinkedOrdersApiResponse,
  PartTransferCheckResponse,
  TransferOrderDetailsByTransferIdApiResponse,
  TransferOrderListApiResponse,
  TransferOrderPickResponse,
  TransferOrderHistoryResponse
} from "../../@types/DRO/TransferOrderResponse";
import {
  CreateTransferOrderBody,
  PartTransferCheckRequest,
  ReturnTransferOrderBody,
  TransferOrderPickBody,
} from "../../@types/DTO/CreateTransferOrderBody";

import { erpAxios, getAuthToken } from "../axiosInstances";
import { ERP_BASE_URL } from "../../config/apiConfig";

export class TransferOrderApi {
  public static api = new TransferOrderApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getAllTransferOrderApi(
    page?: number,
    pageSize?: number,
    search?: string,
    startDate?: string,
    endDate?: string,
    status?: string,
    type?: string
  ): Promise<TransferOrderListApiResponse> {
    try {
      const response: AxiosResponse<TransferOrderListApiResponse> =
        await this.instance.get("/erp/api/v1/transfer-order/all", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page,
            pageSize,
            search,
            startDate,
            endDate,
            status,
            type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }
  async getTransferOrderDetailsByTransferId(
    transferOrderId: number,
    search?: string,
    startDate?: string,
    endDate?: string,
    page = 1,
    pageSize = 10
  ): Promise<TransferOrderDetailsByTransferIdApiResponse> {
    try {
      const response: AxiosResponse<TransferOrderDetailsByTransferIdApiResponse> =
        await this.instance.get(
          `/erp/api/v1/transfer-order/${transferOrderId}`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
            params: {
              page,
              pageSize,
              search,
              startDate,
              endDate,
            },
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }

  async createTransferOrder(
    orderBody: CreateTransferOrderBody
  ): Promise<TransferOrderPickResponse> {
    try {
      const response: AxiosResponse<TransferOrderPickResponse> =
        await this.instance.post(
          `/erp/api/v1/transfer-order/create`,
          orderBody,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
          }
        );
      console.log("Purchase order created successfully");
      return response.data;
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }
  async updateTransferOrder(
    orderId: number,
    orderBody: CreateTransferOrderBody
  ): Promise<TransferOrderPickResponse> {
    try {
      const response: AxiosResponse<TransferOrderPickResponse> =
        await this.instance.put(
          `/erp/api/v1/transfer-order/update?id=${orderId}`,
          orderBody,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
          }
        );
      console.log("Purchase order created successfully");
      return response.data;
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }
  async changeTransferOrderStatus(
    id: number,
    status: string
  ): Promise<ChangeStatusResponse> {
    try {
      const response: AxiosResponse<ChangeStatusResponse> =
        await this.instance.put(
          `/erp/api/v1/transfer-order/change/status`,
          status,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
            params: {
              id,
            },
          }
        );
      console.log("Transfer order status changed successfully");
      return response.data;
    } catch (error) {
      console.error("Error changing transfer order status", error);
      throw error;
    }
  }

  async transferOrderPickup(
    id: number,
    body: TransferOrderPickBody
  ): Promise<TransferOrderPickResponse> {
    try {
      const response: AxiosResponse<TransferOrderPickResponse> =
        await this.instance.put(`/erp/api/v1/transfer-order/pick`, body, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            id,
          },
        });
      console.log("Transfer order status changed successfully");
      return response.data;
    } catch (error) {
      console.error("Error during transfer order pickup", error);
      throw error;
    }
  }
  async createReturnTransferOrder(
    orderBody: ReturnTransferOrderBody
  ): Promise<void> {
    try {
      await this.instance.post(`/erp/api/v1/transfer-order/create`, orderBody, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      console.log("Purchase order created successfully");
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }
  async checkPartTransferTransition(
    request: PartTransferCheckRequest
  ): Promise<PartTransferCheckResponse> {
    try {
      const response: AxiosResponse<PartTransferCheckResponse> =
        await this.instance.get(
          "/erp/api/v1/transfer-order/part-transition/check",
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
            params: request,
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error checking part transfer", error);
      throw error;
    }
  }

  // Linked Transfer Order API
  async getLinkedTransferOrderApi(
    id: number
  ): Promise<GetAllLinkedOrdersApiResponse> {
    try {
      const response: AxiosResponse<GetAllLinkedOrdersApiResponse> =
        await this.instance.get(`/erp/api/v1/transfer-order/linked/${id}`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            id,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }

  async getTransferOrderHistory(id: number): Promise<TransferOrderHistoryResponse> {
    try {
      const response: AxiosResponse<TransferOrderHistoryResponse> =
        await this.instance.get(`/erp/api/v1/transfer-order/history`, {
          params: { id },
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching transfer order history:", error);
      throw error;
    }
  }
}


